import type { PropsWithChildren } from "react"
import { UserShieldIcon } from "../Icon"

export type NoticePropsType = PropsWithChildren<{
  withIcon?: boolean
}>

export const Notice = ({ withIcon = false, children }: NoticePropsType) => (
  <div className="cobalt-notice">
    {withIcon && (
      <div>
        <UserShieldIcon size={20}></UserShieldIcon>
      </div>
    )}

    <div className="cobalt-notice__content">{children}</div>
  </div>
)

export default Notice
